/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WarehouseAddressDTOFromJSON, WarehouseAddressDTOToJSON, } from './WarehouseAddressDTO';
import { WarehouseLinkDTOFromJSON, WarehouseLinkDTOToJSON, } from './WarehouseLinkDTO';
import { WarehouseMarketCarriersDTOFromJSON, WarehouseMarketCarriersDTOToJSON, } from './WarehouseMarketCarriersDTO';
import { WarehouseDTOFromJSON, WarehouseDTOToJSON, } from './WarehouseDTO';
/**
 * Check if a given object implements the WarehouseInfoDTO interface.
 */
export function instanceOfWarehouseInfoDTO(value) {
    return true;
}
export function WarehouseInfoDTOFromJSON(json) {
    return WarehouseInfoDTOFromJSONTyped(json, false);
}
export function WarehouseInfoDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'warehouse': json['warehouse'] == null ? undefined : WarehouseDTOFromJSON(json['warehouse']),
        'link': json['link'] == null ? undefined : WarehouseLinkDTOFromJSON(json['link']),
        'address': json['address'] == null ? undefined : WarehouseAddressDTOFromJSON(json['address']),
        'carriers': json['carriers'] == null ? undefined : (json['carriers'].map(WarehouseMarketCarriersDTOFromJSON)),
        'contractAvailable': json['contractAvailable'] == null ? undefined : json['contractAvailable'],
    };
}
export function WarehouseInfoDTOToJSON(json) {
    return WarehouseInfoDTOToJSONTyped(json, false);
}
export function WarehouseInfoDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'warehouse': WarehouseDTOToJSON(value['warehouse']),
        'link': WarehouseLinkDTOToJSON(value['link']),
        'address': WarehouseAddressDTOToJSON(value['address']),
        'carriers': value['carriers'] == null ? undefined : (value['carriers'].map(WarehouseMarketCarriersDTOToJSON)),
        'contractAvailable': value['contractAvailable'],
    };
}
